import { Card, Col } from 'reactstrap'
import { BadgeTagsWithIcons } from '../../../../utils/Constant'
import CommonTagAndPillsCardBody from '../Common/CommonTagAndPillsCardBody'
import { iconContext, iconData } from '../../../../Data/Ui-Kits/TagAndPills/TagAndPills'
import CommonCardHeader from '../../../../CommonElements/CommonCardHeader/CommonCardHeader'

const BadgeTagsWithIconsCart = () => {
  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={BadgeTagsWithIcons} span={iconData} />
        <CommonTagAndPillsCardBody number={iconContext} />
      </Card>
    </Col>
  )
}

export default BadgeTagsWithIconsCart